// Auto-generated search result templates map
import figureTemplate from "/home/runner/work/berkeley-stress-test/berkeley-stress-test/content/search/_result-figure.mdx";
export const figure = figureTemplate;
import articleTemplate from "/home/runner/work/berkeley-stress-test/berkeley-stress-test/content/search/_result-article.mdx";
export const article = articleTemplate;
export default { figure, article };